// enter file of limited Konva version with only core functions
export { Konva } from "./_CoreInternals.js";
import { Konva } from "./_CoreInternals.js";
export default Konva;
